<template>
  <div class="main-wrapper m-bg">
    <div class="w-container">
      <!-- actual layout -->
      <v-row class="pa-0 ma-0" >
        <v-col cols="4" class="w-content pa-1">
          <dockBatch :value="1" :key="dockBatchKeys[0]"></dockBatch>
        </v-col>
        <v-col cols="4" class="w-content pa-1">
           <dockBatch :value="2" :key="dockBatchKeys[1]"></dockBatch>
        </v-col>        
        <v-col cols="4" class="main-plan w-content pa-1">
           <dockBatch :value="3" :key="dockBatchKeys[2]"></dockBatch>
        </v-col>
       
      </v-row>
      <v-row class="pa-0 ma-0">
        <v-col cols="7" class="pa-1 w-content">
          <statusManPower :key="statusManPowerKey"/>
        </v-col>
        <v-col cols="5" class="pa-1 w-content">
          <statusInspection :key="statusInspectionKey"/>
        </v-col>
      </v-row>
     
    </div>
  </div>
</template>

<script>

import dockBatch from './v20a6000pcDockBatch'
import statusManPower from './v20a6000pcStatusMP'
import statusInspection from './v20a6000pcStatusInspection'


export default {
  name: 'v20a6000pc',
  components: {
    dockBatch,
    statusManPower,
    statusInspection
  },
  props: {
    isHidden: Boolean,
    routeName: String,
  },
  
  data() {
    return {
      dockBatchKeys: [1, 2, 3], // Key để buộc Vue re-render
      statusManPowerKey: 1,
      statusInspectionKey: 1
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown; // Trả về true nếu màn hình nhỏ hơn mobileBreakpoint (mặc định 1264px)
    },
    screenSize() {
      return this.$vuetify.breakpoint.name; // Trả về tên breakpoint: 'xs', 'sm', 'md', 'lg', 'xl'
    },
   
  },
  watch: {
    isMobile(newValue) {
      // console.log("isMobile_pc: ", newValue);
    },

    screenSize(newValue){
      // console.log("screenSize_pc: ", newValue);
    }
     
  },
  methods: {
    autoReloadComponents() {
      setInterval(() => {
        // Thay đổi key để Vue render lại component
        this.dockBatchKeys = this.dockBatchKeys.map(key => key + 1);
        this.statusManPowerKey += 1;
        this.statusInspectionKey += 1;
      }, 60000); // 60 giây
    }
  },
  mounted() {
    this.autoReloadComponents();
  },

  beforeDestroy() {
    // console.log("beforeDestroy: "+this.$options.name + "_search");
  },

  created() {
  },

}
</script>
<style lang="less" scoped></style>
